import { render } from "./MailAddressRegistrationPage.vue?vue&type=template&id=e491bf60&scoped=true"
import script from "./MailAddressRegistrationPage.vue?vue&type=script&lang=ts"
export * from "./MailAddressRegistrationPage.vue?vue&type=script&lang=ts"

import "./MailAddressRegistrationPage.vue?vue&type=style&index=0&id=e491bf60&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-e491bf60"
/* hot reload */
if (module.hot) {
  script.__hmrId = "e491bf60"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e491bf60', script)) {
    api.reload('e491bf60', script)
  }
  
  module.hot.accept("./MailAddressRegistrationPage.vue?vue&type=template&id=e491bf60&scoped=true", () => {
    api.rerender('e491bf60', render)
  })

}

script.__file = "src/views/registerTeam/MailAddressRegistrationPage.vue"

export default script